/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a price Field.
 */
import { mapGetters } from 'vuex';
import priceFieldService from './../../../../services/priceField';
import priceFieldTransformer from './../../../../transformers/priceField';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      form: new Forms({
        field: {
          value: '',
          type: 'text',
        },
      }),
      loading: false,
    };
  },

  created() {
    this.show();
  },

  computed: {
    
  },

  methods: {
    /**
     * Method to update the price Field.
     */
    update() {
      this.form.loading = true;
      const priceField = priceFieldTransformer.send(this.form.data());
      priceFieldService.update(store.state.route.params.id, priceField)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.priceFields.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'priceFields.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the price Field object for editing.
     */
    show() {
      this.loading = true;
      priceFieldService.show(store.state.route.params.id).then((priceField) => {
        this.form.assignData(priceField);
        this.loading = false;
      });
    },
  },

  watch: {
   
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/priceFields/edit/edit.js